module.exports = __webpack_public_path__ + "static/media/Video_Thumbnail.aa706c0f.png";